import { commonProps } from '@duda-co/host-services';
import {
    FeatureFlags,
    PropertyDefaultValue,
} from 'shared-services/types/feature-flags';

const FLAG_PREFIX = 'runtime.ssr.';

export const featureFlags: FeatureFlags = {
    getBoolean: (key, defaultValue = false) => {
        if (!key.startsWith(FLAG_PREFIX)) {
            throw new Error(`Flag must contains ${FLAG_PREFIX}`);
        }
        return commonProps.getFlag(key, defaultValue) as boolean;
    },
    getProperty: <Value extends PropertyDefaultValue>(
        key: string,
        defaultValue?: Value
    ) => {
        return commonProps.get(key, defaultValue) as Value;
    },
    getServiceFlags: () => {
        throw new Error('not implemented');
    },
    initServiceFlags: async () => {
        throw new Error('not implemented');
    },
};
